import Button from "../../../components/button/Button";
import ArrowSmall from "../../../components/svg/ArrowSmall";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
	selectOpenBills,
	selectReservation,
	selectReservations,
	setOpenBills,
} from "../../../features/reservation/reservationSlice";
import { getTotalPersons } from "../../../helpers/reservation";
import Payment from "../../../components/kiosk/Payment";
import { useEffect, useState } from "react";
import { get } from "../../../helpers/api";
import { showSnackbar } from "../../../helpers/notification";
import Loading from "../../../components/svg/Loading";

export default function OpenBillsAccount() {
	const reservation = useSelector(selectReservation);
	const reservations = useSelector(selectReservations);
	const openBills = useSelector(selectOpenBills);
	const dispatch = useDispatch();
	const [loadingOpenBills, setLoadingOpenBills] = useState<boolean>(true);
  const [nextPage, setNextPage] = useState<string>("/kiosk/check-in/select-reservation");
	const navigate = useNavigate();

	useEffect(() => {
		getOpenBills();
    
    if(reservations.length === 1) {
      setNextPage("/kiosk/check-in/customer-form/0");
    } else {
      setNextPage("/kiosk/check-in/select-reservation");
    }
	}, []);

	const getOpenBills = () => {
		get({
			url: `consumption/open-bills/get`,
			params: { 
        accountIds: reservation.AccountId,
        endDate: reservations[0].EndAt
      },
		})
			.then((response) => {
				if (response.data && response.data.Success) {
					dispatch(setOpenBills(response.data.OpenBills));
					setTimeout(() => {
						setLoadingOpenBills(false);
					}, 300);
				}
			})
			.catch((error) => {
				showSnackbar(error.response?.data.message, "error", "top-center");
			});
	};

	return (
		<div className="flex-grow flex justify-center items-center flex-col w-full">
			<div className="text-h1 text-center">
				Hi {reservation.FirstNames}, <br />
				You’re here. Finally!
			</div>

			<div className="mt-6 mb-6 w-full">
				<div className="bg-white/75 rounded-xl p-4 grid grid-cols-2 gap-y-6 w-full">
					<div>
						<span className="text-gray-600">Confirmation number(s)</span>
						<br />
						{reservations.map((reservation, i) => {
							return (
								<span key={i}>
									{reservation?.ReservationNumber}
									<br />
								</span>
							);
						})}
					</div>
					<div>
						<span className="text-gray-600">Room type(s)</span>
						<br />
						{reservations.map((reservation, i) => {
							return (
								<span key={i}>
									{reservation?.ResourceCategoryName}
									<br />
								</span>
							);
						})}
					</div>
					<div>
						<span className="text-gray-600">Arrival</span>
						<br />
						{reservations[0]?.CheckInAt}
					</div>
					<div>
						<span className="text-gray-600">Departure</span>
						<br />
						{reservations[0]?.CheckOutAt}
					</div>
					<div>
						<span className="text-gray-600">Travellers</span>
						<br />
						{getTotalPersons()}
					</div>
				</div>
			</div>

			{loadingOpenBills === true ? (
				<div className="w-full bg-white/75 rounded-xl p-4 h-96 overflow-y-auto flex flex-col items-center justify-center">
					<Loading className="w-12 h-12 text-black animate-loading" />
					<div className="">Looking for open bills</div>
				</div>
			) : (
				<div className="w-full">
					{openBills !== null && (
						<Payment
							openBills={openBills}
							minimalAmount={0.1}
							callBack={() => navigate(nextPage)}
						/>
					)}

					{openBills?.Total?.GrossValue !== undefined &&
						openBills?.Total?.GrossValue <= 0.1 && (
							<div className="mt-4">
								<Button
									link={nextPage}
									text="Next"
									suffix={<ArrowSmall />}
								/>
							</div>
						)}
				</div>
			)}
		</div>
	);
}
